<template>
  <vs-popup
    class="sign-off-taste-panel-popup"
    title="SIGN OFF"
    :active.sync="open"
    :buttons-hidden="true"
    @close="closePopup"
  >
    <!-- <vx-card no-shadow class="mb-4">
      <div>
        <h5 class="mb-4 font-semibold">
          {{ batchTitle }}
        </h5>

        <div class="mb-5">
          <small class="label">
            {{ batchLabel }}
          </small>

          <v-select
            v-model="selected_batch"
            :options="lastBatchTestList"
            :label="selectLabel"
            :clearable="false"
            :closeOnSelect="true"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
        </div>

        <div
          v-if="
            selected_batch &&
            selected_batch.latest_quality_control_batch_sign_off
          "
        >
          <div class="grid grid-cols-2 gap-x-8 gap-y-4 text-sm">
            <div>
              <div class="text-gray-500 mb-1">
                {{ batchCodeLabel }}
              </div>
              <div class="font-medium">
                {{ batchCode || "-" }}
              </div>
            </div>

            <div>
              <div class="text-gray-500 mb-1">Taste Panel</div>
              <div class="font-medium">
                <HyperLink
                  :id="
                    selected_batch.latest_quality_control_batch_sign_off.group
                      .id
                  "
                  type="tasting-group"
                >
                  {{
                    selected_batch.latest_quality_control_batch_sign_off.group
                      .code
                  }}
                </HyperLink>
              </div>
            </div>

            <div>
              <div class="text-gray-500 mb-1">Signed At</div>
              <div class="font-medium">
                {{
                  selected_batch.latest_quality_control_batch_sign_off
                    .signed_at || "-"
                }}
              </div>
            </div>

            <div>
              <div class="text-gray-500 mb-1">Status</div>
              <div class="font-medium">
                {{
                  selected_batch.latest_quality_control_batch_sign_off.status ||
                  "-"
                }}
              </div>
            </div>

            <div class="col-span-2">
              <div class="text-gray-500 mb-1">Signed By</div>
              <div class="font-medium">
                {{
                  selected_batch.latest_quality_control_batch_sign_off.signed_by
                    .name || "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <div v-else class="py-6 text-center text-sm text-gray-500">
          No previous test result selected.
        </div>
      </div>
    </vx-card> -->

    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(signOff)" autocomplete="off">
          <!-- <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="border p-3 rounded-lg space-y-1">
              <small>Specific Gravity</small>
              <vs-input
                :disabled="updateMode"
                v-model="form.specific_gravity"
                class="w-full"
              />
            </div>

            <div class="border p-3 rounded-lg space-y-1">
              <small>Reactive Index</small>
              <vs-input
                :disabled="updateMode"
                v-model="form.reactive_index"
                class="w-full"
              />
            </div>

            <div class="border p-3 rounded-lg space-y-1">
              <small>Moisture</small>
              <vs-input
                :disabled="updateMode"
                v-model="form.moisture"
                class="w-full"
              />
            </div>

            <div class="border p-3 rounded-lg space-y-1">
              <small>Target</small>
              <vs-input
                :disabled="updateMode"
                v-model="form.target"
                class="w-full"
              />
            </div>
          </div> -->

          <div class="mt-4 space-y-4">
            <ValidationProvider
              name="Status"
              rules="required"
              v-slot="{ errors }"
            >
              <div class="space-y-1">
                <div class="text-sm font-semibold">Status</div>
                <v-select
                  v-model="form.status"
                  :options="signOffStatuses"
                  :reduce="(option) => option.value"
                  label="label"
                  :clearable="false"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :disabled="updateMode"
                />
                <span class="text-xs text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>

            <ValidationProvider name="Comment" v-slot="{ errors }">
              <div class="space-y-1">
                <div class="text-sm font-semibold">Comment</div>
                <vs-textarea
                  :disabled="updateMode"
                  v-model="form.comment"
                  class="w-full"
                />
                <span class="text-xs text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </div>

          <div class="flex justify-end items-center gap-3 mt-6">
            <vs-button type="border" color="danger" @click="closePopup">
              Cancel
            </vs-button>
            <vs-button type="filled" button="submit" v-if="!updateMode">
              Sign Off
            </vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>
<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import vSelect from "vue-select";
import moment from "moment/moment";

const TriangleTestsRepository = RepositoryFactory.get("triangle_tests");
const ManufacturingRepository = RepositoryFactory.get("manufacturing");

export default {
  name: "signOffTastePanel",
  data() {
    return {
      open: false,
      form: {
        comment: "",
        status: "",
      },
      tastingGroupResult: {},
      signOffStatuses: [],
      batchId: null,
      batchType: "",
      updateMode: false,
      lastBatchTestList: [],
      selected_batch: null,
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    isRawMaterial() {
      return this.batchType === "Raw Material Inventory";
    },

    batchTitle() {
      return this.isRawMaterial
        ? "Result for Last Tested Batch"
        : "Result for Last Tested Work Order";
    },

    batchLabel() {
      return this.isRawMaterial ? "RM Batch" : "Work Order";
    },

    batchCodeLabel() {
      return this.isRawMaterial ? "Batch Code" : "Work Order Code";
    },

    selectLabel() {
      return this.isRawMaterial ? "code" : "work_order_code";
    },

    batchCode() {
      if (!this.selected_batch) return "-";

      return this.isRawMaterial
        ? this.selected_batch.code
        : this.selected_batch.work_order_code;
    },
  },
  methods: {
    async openPopup(tastingGroupResult, item) {
      this.tastingGroupResult = tastingGroupResult;
      this.batchId = item.id;
      this.batchType = this.getBatchType(item.pivot.groupable_type);
      this.rmWoId = this.getWoRmCode(item);
      await this.getListOfSignOffStatuses();
      await this.getTastingGroupSignOff();
      // await this.getLastTestForBatch();
      this.open = true;
    },
    closePopup() {
      this.open = false;
    },
    async getListOfSignOffStatuses() {
      try {
        this.$vs.loading();
        const response =
          await TriangleTestsRepository.getListOfSignOffStatuses();
        this.signOffStatuses = response.data.data;
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
      }
    },
    getWoRmCode(item) {
      const type = this.getBatchType(item.pivot.groupable_type);
      if (type === "Raw Material Inventory") {
        return `${item.staff_raw_material_order_item.raw_material.category.prefix}-${item.staff_raw_material_order_item.raw_material.company_product_code}`;
      }
      if (type === "Work Order") {
        return item.formulation.formulation_code;
      }
    },

    async getLastTestForBatch() {
      try {
        this.$vs.loading();


        const response = this.isRawMaterial
          ? await ManufacturingRepository.getRawMaterialStockForTastePanel(
              `filter[raw-material-code]=${this.rmWoId}&sort=-signed-at`
            )
          : await ManufacturingRepository.getWoForTastePanel(
              `filter[formulation-code]=${this.rmWoId}&sort=-signed-at`
            );

        const batches = response.data.data;

        const labStandard = {
          code: "Lab Standard",
          work_order_code: "Lab Standard",
          is_lab_standard: true,
        };

        this.lastBatchTestList = [...batches, labStandard];

        if (!batches.length) {
          this.selected_batch = labStandard;
          return;
        }

        const latestBatch = batches[0];

        const signedAt =
          latestBatch.latest_quality_control_batch_sign_off.signed_at;

        if (!signedAt) {
          this.selected_batch = labStandard;
          return;
        }

        const lastTestDate = moment(signedAt, "DD/MM/YYYY HH:mm:ss");

        const monthsSinceLastTest = moment().diff(lastTestDate, "months");

        this.selected_batch =
          monthsSinceLastTest > 12 ? labStandard : latestBatch;
      } catch (error) {
      } finally {
        this.$vs.loading.close();
      }
    },
    getLastBatchProp(name) {
      const signOff = this.lastBatchTest.latest_quality_control_batch_sign_off;

      if (!signOff || !signOff.optional_properties) return "-";

      const prop = signOff.optional_properties.find((p) => p.name === name);
      return prop ? prop.response : "-";
    },
    async getTastingGroupSignOff() {
      try {
        this.$vs.loading();
        await this.resetForm();
        const response = await TriangleTestsRepository.getTastingGroupSignOff(
          this.tastingGroupResult.id,
          this.batchType,
          this.batchId
        );
        const data = response.data.data;

        if (!data || !data.length) {
          this.$vs.loading.close();
          return;
        }

        if (data.length > 0) {
          this.updateMode = true;
        }
        this.form.status = data[0].status;
        this.form.comment = data[0].comment;
        this.form.specific_gravity = data[0].optional_properties.find(
          (property) => property.name === "Specific Gravity"
        ).response;
        this.form.reactive_index = data[0].optional_properties.find(
          (property) => property.name === "Refractive Index"
        ).response;
        this.form.moisture = data[0].optional_properties.find(
          (property) => property.name === "Moisture"
        ).response;
        this.form.target = data[0].optional_properties.find(
          (property) => property.name === "Target"
        ).response;
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
      }
    },
    async resetForm() {
      this.form = {
        comment: "",
        status: "",
        specific_gravity: "",
        reactive_index: "",
        moisture: "",
        target: "",
      };
      this.updateMode = false;
    },
    getBatchType(typeString) {
      var typeMap = {
        "Modules\\TenentCore\\Entities\\Staff\\Manufacture\\WorkOrder":
          "Work Order",
        "Modules\\TenentCore\\Entities\\Staff\\Manufacture\\RawMaterialStockInventory":
          "Raw Material Inventory",
      };
      return typeMap[typeString];
    },
    async signOff() {
      try {
        const payload = {
          comment: this.form.comment,
          status: this.form.status,
          batch_id: this.batchId,
          batch_type: this.batchType,
          optional_properties: [
            {
              response: this.form.specific_gravity,
              name: "Specific Gravity",
            },
            {
              response: this.form.reactive_index,
              name: "Refractive Index",
            },
            {
              response: this.form.moisture,
              name: "Moisture",
            },
            {
              response: this.form.target,
              name: "Target",
            },
          ],
        };
        const response = await TriangleTestsRepository.signOffTastingGroup(
          this.tastingGroupResult.id,
          payload
        );
        this.closePopup();
        this.$emit("refresh");
      } catch (error) {}
    },
  },
};
</script>
<style scoped>
.sign-off-taste-panel-popup >>> .vs-popup {
  /*min-height: 50% !important;*/
  min-width: 50% !important;
}
</style>
